import React from 'react';
import styled from 'styled-components';

import { FiMail, FiPhone } from 'react-icons/fi'


const Container = styled.div`
  h3 {
    color: #fff;
  }
`

const Header = styled.div`
  margin-bottom: 50px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    display: flex;
    align-items: center;
  }
`

const Image = styled.div`
  background-image: url(${props => props.file});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 180px;
  height: 200px;
  width: 200px;
`

const ThankYou = (props) => (
  <Container>
    <Header>
      <h1>{props.copy.h1}</h1>
      <h3>{props.copy.h3}</h3>
    </Header>

    <Body>
      <Image file={props.copy.image}/>
      <p><FiPhone size="18" style={{marginRight: '10px'}}/>{props.copy.phone}</p>
      <p><FiMail size="18" style={{marginRight: '10px'}}/>{props.copy.mail}</p>
    </Body>
  </Container>
)

export default ThankYou
